// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "2f21af910429914fb9c61ad7357fa189" + ".js";
};